export const NAVIGATION = {
  INDACATORS_SIGNALS: {
    id: 0,
    name: 'Biomarkers',
    url: 'biomarkers',
  },
  SIGNALS: {
    id: 1,
    name: 'Signals',
    url: 'signals',
  },
  INTERPRETATIONS: {
    id: 2,
    name: 'Diseases',
    url: 'diseases',
  },
  RECOMENDATIONS: {
    id: 3,
    name: 'Recommendations',
    url: 'recommendations',
  },
  SETTING: {
    id: 4,
    name: 'Settings',
    url: 'settings',
  },
  CREATE_INDICATOR: {
    id: 5,
    name: 'Create Indicator',
    url: 'create-biomarker',
  },
  CREATE_RECOMMENDATION: {
    id: 5,
    name: 'Create Recommendation',
    url: 'create-recommendation',
  },
  CREATE_INTERPRETATION: {
    id: 5,
    name: 'Create Interpretation',
    url: 'create-interpretation',
  },
  CREATE_SIGNALS: {
    id: 5,
    name: 'Create Signal',
    url: 'create-signal',
  },
  CREATE_SUBJECT: {
    id: 5,
    name: 'Create Subject',
    url: 'create-theme',
  },
  PROM: {
    id: 6,
    name: 'PROM',
    url: 'prom',
  },
}
